import React from "react";
import { Link } from "react-router-dom";

import "../assets/Home.css";

const Section3 = () => {
  return (
    <div className="section">
      <div className="portfolios">
        <div className="Links">
          <Link to="/PROJECTS">
            <button>PROJECTS</button>
          </Link>
          <Link to="/CREATIVES">
            <button>CREATIVES</button>
          </Link>
          <Link to="/RESUME">
            <button>RESUME</button>
          </Link>
        </div>
      </div>
      <div className="HomeEnd">
        <a
          href="mailto: veditbeladia@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          E-Mail
        </a>
        <a
          href="https://github.com/v3dit"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          href="https://www.linkedin.com/in/vedit-beladia/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <a
          href="https://www.instagram.com/veditbeladia/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>
        <a
          href="https://djsce.ac.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Currently At
        </a>
      </div>
    </div>
  );
};

export default Section3;
